import * as React from 'react';

const ChevronDownBlackSvg = props => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M17 10H7l5 5 5-5Z" fill="#111" />
    </svg>
);

export default ChevronDownBlackSvg;
